import Funding from './funding.js';
export default Funding;
